import React from 'react';
import S from 'common/service/sanctuary';
import Textfield from 'common/mdc/textfield';
import { func, bool } from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';

import {
  EMPTY,
  NOT_EMPTY,
  EQUALS,
  NOT_EQUALS,
  translateOperator,
} from './operator';

import SearchConstraint, { constraintShape } from './constraint';

const messages = defineMessages({
  notEquals: {
    id: 'search.advanced.criteria.constraint.notEquals',
    defaultMessage: 'not {value}',
  },
});

export const translateConstraint = constraint => S.pipe([
  S.get(S.is(String), 'operator'),
  S.chain(operator => S.toMaybe(({
    [EMPTY]: translateOperator(constraint.operator),
    [NOT_EMPTY]: translateOperator(constraint.operator),
    [EQUALS]: constraint.value ? constraint.value : null,
    [NOT_EQUALS]: constraint.value ? (
      <FormattedMessage
        values={{
          value: constraint.value,
        }}
        {...messages.notEquals}
      />
    ) : null,
  })[operator])),
])(constraint);

const getContent = (constraint, props) => ({
  [EMPTY]: null,
  [NOT_EMPTY]: null,
  [EQUALS]: <Textfield {...props} />,
  [NOT_EQUALS]: <Textfield {...props} />,
})[constraint.operator];

const Plain = ({
  nullable,
  constraint,
  onValueChange,
  ...props
}) => (
  <SearchConstraint
    {...props}
    constraint={constraint}
    operators={[
      nullable && EMPTY,
      nullable && NOT_EMPTY,
      EQUALS,
      NOT_EQUALS,
    ].filter(Boolean)}
  >{getContent(constraint, {
    className: 'criteria-input',
    value: constraint.value || '',
    onChange: e => onValueChange(e.target.value),
    onKeyDown: (e) => {
      e.stopPropagation();
    },
  })}
  </SearchConstraint>
);

Plain.propTypes = {
  nullable: bool,
  constraint: constraintShape.isRequired,
  onValueChange: func.isRequired,
};

Plain.defaultProps = {
  nullable: false,
};

export default Plain;
